import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { dateIsValid } from '../helpers';

@Injectable()
export class FormsValidators {
  static POSTCODE_REGEX =
    /^(([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? ?){1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/i;
  static MONEY_REGEX = /^\d{1,18}(\.\d{1,2})?$/;
  static EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@[*[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+]*/;
  static TELEPHONE_REGEX = /^([()\-.\\/+# 0-9x]|ext|extension)+$/;
  static DOMAIN_REGEX = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/;

  static date(formControl: AbstractControl) {
    const value = formControl.value;
    const valid = value && dateIsValid(value);
    return valid ? undefined : { date: true };
  }

  static trueOrFalse(formControl: AbstractControl) {
    const valid = formControl.value === true || formControl.value === false;
    return valid ? undefined : { required: true };
  }

  static percentage(control: AbstractControl) {
    const value = parseFloat(control.value);
    const valid = !isNaN(value) && value >= 0 && value <= 100;
    return valid ? undefined : { percentage: true };
  }

  static integer(formControl: AbstractControl) {
    const value = +formControl.value;
    const valid = typeof value === 'number' && !isNaN(value) && Number.isInteger(value);
    return valid ? undefined : { integer: true };
  }

  static number(formControl: AbstractControl) {
    const value = +formControl.value;
    const valid = typeof value === 'number' && !isNaN(value);
    return valid ? undefined : { number: true };
  }

  static greaterThan(min: number): any {
    return (formControl: AbstractControl) => {
      const value = +formControl.value;
      const valid = typeof value === 'number' && !isNaN(value) && value > min;
      return valid ? undefined : { greaterThan: min };
    };
  }

  static lessThan(max: number): any {
    return (formControl: AbstractControl) => {
      const value = +formControl.value;
      const valid = typeof value === 'number' && !isNaN(value) && value < max;
      return valid ? undefined : { lessThan: max };
    };
  }

  static greaterThanOrEqual(min: number): any {
    return (formControl: AbstractControl) => {
      const value = +formControl.value;
      const valid = typeof value === 'number' && !isNaN(value) && value >= min;
      return valid ? undefined : { greaterThanOrEqual: min };
    };
  }

  static lessThanOrEqual(max: number): any {
    return (formControl: AbstractControl) => {
      const value = +formControl.value;
      const valid = typeof value === 'number' && !isNaN(value) && value <= max;
      return valid ? undefined : { lessThanOrEqual: max };
    };
  }

  static containsUppercase(formControl: AbstractControl) {
    const valid = /[A-Z]+/.test(formControl.value);
    return valid ? undefined : { containsUppercase: true };
  }

  static containsLowercase(formControl: AbstractControl) {
    const valid = /[a-z]+/.test(formControl.value);
    return valid ? undefined : { containsLowercase: true };
  }

  static containsNonAlphaNumeric(formControl: AbstractControl) {
    const valid = /[^a-zA-Z0-9]/.test(formControl.value);
    return valid ? undefined : { containsNonAlphaNumeric: true };
  }

  static containsNumbers(formControl: AbstractControl) {
    const valid = /[0-9]+/.test(formControl.value);
    return valid ? undefined : { containsNumbers: true };
  }

  static noNumbers(formControl: AbstractControl) {
    const valid = /[^0-9]+/.test(formControl.value);
    return valid ? undefined : { noNumbers: true };
  }

  static email(formControl: AbstractControl) {
    const valid = formControl.value && FormsValidators.EMAIL_REGEX.test(formControl.value);
    return valid ? undefined : { email: true };
  }

  // https://www.regexpal.com/?fam=104738
  static telephone(formControl: AbstractControl) {
    const valid = formControl.value && FormsValidators.TELEPHONE_REGEX.test(formControl.value);
    return valid ? undefined : { telephone: true };
  }

  static domain(formControl: AbstractControl) {
    const valid = FormsValidators.DOMAIN_REGEX.test(formControl.value);
    return valid ? undefined : { invalidDomain: true };
  }

  static postcode(control: AbstractControl) {
    const valid = FormsValidators.POSTCODE_REGEX.test(control.value);
    return valid ? undefined : { invalidPostcode: true };
  }

  static money(control: AbstractControl) {
    const valid = FormsValidators.MONEY_REGEX.test(control.value);
    return valid ? undefined : { money: true };
  }
}
